import React from 'react'
import axios from '@/utils/myAxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { languageTypeList } from '@/utils/constant'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    Input,
    Button,
    Table,
    Pagination,
    message,
    Modal,
    Select,
    Form,
    Tabs,
} from 'antd'

// 表单数据
const formData = {
    kind: undefined,
    client_channel: undefined,
    title: {
        zh: undefined, // 中文繁体
        th: undefined, // 泰文
        vn: undefined, // 越南文
        id: undefined, // 印尼文
        pt: undefined, // 葡萄牙文
        ko: undefined, // 韩文
        spa: undefined, // 西班牙文
        lao: undefined, // 老挝语
        my: undefined, // 缅甸语
        jp: undefined, // 日文
        bn: undefined, // 孟加拉语
        rs: undefined, // 俄罗斯语
        tr: undefined, // 土耳其语
    },
    url: undefined,
}

export default class CustomerManage extends React.Component {
    state = {
        loading: false, // 是否加载中
        show: false, // 新增弹窗
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        formData: { ...formData }, // 表单数据
        data: [], // 表格数据
        channelList: [], // 渠道列表,
        languageTypeList: languageTypeList, // 语言类型列表
        statusType: [ // 状态列表
            { label: this.props.language['close'], value: 0 },
            { label: this.props.language['open'], value: 1 },
        ],
        customerType: [ // 客服类型
            { label: 'telegram', value: 1 },
            { label: 'whatsapp', value: 2 },
            { label: 'line', value: 3 },
            { label: 'messenger', value: 4 },
            { label: this.props.language['onlineCustomer'], value: 5 },
        ],
        activeNameKey: 'en', // 激活的名称tab
        selectedData: {}, // 选中的表格数据
    };

    componentDidMount () {
        this.fetchData()
        this.fetchChannelList()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/support/list')
            .then((res) => {
                this.setState({
                    loading: false,
                    data: res.data || []
                })
            })
    };

    /**
     * 获取渠道列表
     */
    fetchChannelList = () => {
        axios
            .get('/v1/api/support/channel_list')
            .then((res) => {
                this.setState({
                    channelList: res.data || []
                })
            })
    };

    /**
     * 新增、编辑
     */
    handleAddOrEdit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post('/v1/api/support/add', {
                        id: this.state.type === 'edit' ? this.state.selectedData.id : undefined,
                        client_channel: values.client_channel,
                        kind: values.kind,
                        title: JSON.stringify(values.title),
                        url: values.url,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            if (this.state.type === 'edit') {
                                message.success(this.props.language["editSuccessMessage"])
                            } else {
                                message.success(this.props.language["createSuccessMessage"])
                            }
                            this.fetchData()
                            this.handleClose()
                        }
                    })
            } else {
                if (err.title) {
                    for (const item of languageTypeList) {
                        for (const key of Object.keys(err.title)) {
                            if (item.value === key) return this.handleChangeActiveNameKey(key)
                        }
                    }
                }
            }
        })
    };

    /**
     * 发布、下线、删除
     */
    handleOperation = (type, item) => {
        axios
            .patch('/v1/api/support/set_status',
                {
                    id: item.id,
                    status: type === 'open' ? 1 : 0
                })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["operationSuccessMessage"])
                    this.fetchData()
                }
            })
    };

    /**
     * 切换激活的名称tab
     */
    handleChangeActiveNameKey = (value) => {
        this.setState({ activeNameKey: value })
    }

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === 'add') {
            // 新增
            this.setState({
                type,
                show: true,
                title: this.props.language['createCustomer'],
            })
        } else if (type === 'edit') {
            // 编辑
            this.setState({
                type,
                show: true,
                title: this.props.language['editCustomer'],
                formData: {
                    client_channel: item.client_channel,
                    kind: item.kind,
                    title: item.title,
                    url: item.url,
                },
                selectedData: { ...item },
            })
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false, formData: { ...formData } });
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    {this.state.channelList.length > 0 &&
                        <Button type="primary" ghost onClick={() => this.handleShow('add')}>
                            {this.props.language["createCustomer"]}
                        </Button>
                    }
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column align="center" title="ID" dataIndex="id" />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusType.find(
                                    (item2) => item2.value == item.status
                                ) ?
                                    this.state.statusType.find(
                                        (item2) => item2.value == item.status
                                    ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["customerType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.customerType.find(
                                    (item2) => item2.value == item.kind
                                ) ?
                                    this.state.customerType.find(
                                        (item2) => item2.value == item.kind
                                    ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["channel"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.channelList.find(
                                    (item2) => item2.id == item.client_channel
                                ) ?
                                    this.state.channelList.find(
                                        (item2) => item2.id == item.client_channel
                                    ).name
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["customerLinkUrl"]}
                            dataIndex="url"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={260}
                            render={(item) => (
                                <>
                                    <Button
                                        className="ml10"
                                        type="primary"
                                        ghost
                                        onClick={() => this.handleShow('edit', item)}
                                    >
                                        {this.props.language["edit"]}
                                    </Button>
                                    {item.status === 0 &&
                                        <Button
                                            className="ml10 btn-green-ghost"
                                            onClick={() => this.handleOperation('open', item)}
                                        >
                                            {this.props.language["open"]}
                                        </Button>
                                    }
                                    {item.status !== 0 &&
                                        <Button
                                            className="ml10"
                                            type="danger"
                                            ghost
                                            onClick={() => this.handleOperation('close', item)}
                                        >
                                            {this.props.language["close"]}
                                        </Button>
                                    }
                                    {/* <Button
                                        className="ml10"
                                        type="danger"
                                        ghost
                                        onClick={() => this.handleOperation('delete', item)}
                                    >
                                        {this.props.language["delete"]}
                                    </Button> */}
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    formData={this.state.formData}
                    customerType={this.state.customerType}
                    channelList={this.state.channelList}
                    languageTypeList={this.state.languageTypeList}
                    activeNameKey={this.state.activeNameKey}
                    handleChangeActiveNameKey={this.handleChangeActiveNameKey}
                    onOk={this.handleAddOrEdit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["customerType"]}>
                                {getFieldDecorator('kind', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["customerTypeVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.kind
                                })(
                                    <Select
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={
                                            this.props.language[
                                            'customerTypePlaceholder'
                                            ]
                                        }
                                    >
                                        {this.props.customerType.map(
                                            (item, index) => (
                                                <Select.Option
                                                    key={index}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                </Select.Option>
                                            )
                                        )}
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["channel"]}>
                                {getFieldDecorator('client_channel', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["channelVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.client_channel
                                })(
                                    <Select
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={
                                            this.props.language[
                                            'channelPlaceholder'
                                            ]
                                        }
                                    >
                                        {this.props.channelList.map(
                                            (item, index) => (
                                                <Select.Option
                                                    key={index}
                                                    value={item.id}
                                                >
                                                    {item.name}
                                                </Select.Option>
                                            )
                                        )}
                                    </Select>
                                )}
                            </Form.Item>
                            <p className='form-label form-label-required'>{this.props.language['title']}</p>
                            <Tabs activeKey={this.props.activeNameKey} onChange={(value) => this.props.handleChangeActiveNameKey(value)}>
                                {languageTypeList.map((item, index) =>
                                    <Tabs.TabPane tab={item.label} key={item.value}>
                                        <Form.Item>
                                            {getFieldDecorator(`title.${item.value}`, {
                                                rules: [
                                                    {
                                                        required: item.value === 'en' ? true : false,
                                                        message:
                                                            this.props.language[
                                                            'titleVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue: this.props.formData.title[item.value],
                                            })(
                                                <Input
                                                    maxLength={60}
                                                    allowClear
                                                    placeholder={
                                                        this.props.language[
                                                        'titlePlaceholder'
                                                        ]
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    </Tabs.TabPane>
                                )}
                            </Tabs>
                            <Form.Item label={this.props.language["customerLinkUrl"]}>
                                {getFieldDecorator('url', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["customerLinkUrlVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.url
                                })(
                                    <Input
                                        maxLength={60}
                                        allowClear
                                        placeholder={this.props.language["customerLinkUrlPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
